module.exports = __webpack_public_path__ + "62490d6969cb90f29009a37eaf11744d.pdf";